/* Native, keyboard-accessible collection tabs. All panels stay available without JavaScript. */
function initSignatureTabs() {
  document.querySelectorAll('[data-sg-tabs]').forEach(root => {
    if (root.dataset.sgReady) return;
    root.dataset.sgReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-sg-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-sg-panel]'));
    const activate = (tab, focus = false) => {
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.sgPanel !== tab.dataset.sgTab; });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
      });
    });
    if (tabs.length) activate(tabs[0]);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSignatureTabs);
else initSignatureTabs();
document.addEventListener('shopify:section:load', initSignatureTabs);
